<template>
  <Popover ref="helpPopover" :showHeader="true" :headerTitle="title" :placement="placement">
    <div class="help-content">
      <slot />
    </div>
  </Popover>
</template>

<style scoped>
.help-content {
  min-width: 400px;
  padding: 8px;
  font-size: 0.75rem;
  line-height: 1rem;
}
</style>

<script>
import Popover from '@/components/popover.vue'

export default {
  name: 'HelpPopover',
  components: {
    Popover
  },
  props: {
    title: {
      type: String,
      default: 'Help Tips'
    },
    placement: {
      type: String,
      default: 'bottom'
    }
  },
  methods: {
    displayFromElement(target) {
      this.$refs.helpPopover.displayFromElement(target)
    }
  }
}
</script>